<google-map height="500px" width="100%" [zoom]="zoom" [center]="center" [options]="options">
  <map-marker [position]="center" [title]="location.Address"> </map-marker>
</google-map>
